<template>
  <transition appear name="slide-down">
    <div class="_modal company-detail">
      <div class="close" @click="CloseModal"><i class="fal fa-times"></i></div>

      <section class="section">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="page-header">
            <h3 class="page-title">Company Information</h3>

            <div class="button-group">
              <button v-if="userId" class="button primary" @click="handleSubmit(updateEmployer)">
                Update
              </button>

              <button @click="handleSubmit(saveEmployerinfo)" v-else class="button primary">
                Save
              </button>
            </div>
          </div>

          <!-- Logo start  -->

          <div class="box">
            <div class="column is-12">
              <div class="upload-photo">
                <div class="user-image" v-if="!imageData" @click="uploadFile()"></div>

                <div class="user-image" v-else :style="{ 'background-image': `url( ${imageData} )` }"
                  @click="uploadFile()"></div>

                <div>
                  <input hidden="hidden" name="image" ref="fileinput" type="file" @input="onSelectFile" />

                  <h3 v-if="!errorfileSize">Please upload your company logo</h3>

                  <label v-if="!errorfileSize">{{ errorfileSize }}</label>

                  <p>Supported file .jpg .png .gif | Maximum 5mb</p>

                  <input hidden="hidden" name="image" v-model="data.logo" type="text" />
                </div>

                <!-- {{form.logo}} -->
              </div>
            </div>
          </div>

          <!-- Logo end -->

          <!-- Login information start -->

          <div class="box">
            <div class="columns is-multiline" v-if="status">
              <div class="column is-4">
                <!-- Company Name -->

                <div class="field">
                  <label for class="label">Select User</label>
                  <div class="control">
                    <ValidationProvider name="User" rules="required" v-slot="{ errors }">
                      <selectionuser v-model="staffID" :data="staff" :updateText="isSelectedUser"
                        :class="{ error: errors[0] }" />
                      <!-- <span style="color: red; font-size: 12px">
                        {{ errors[0] }}
                      </span> -->
                    </ValidationProvider>
                  </div>

                  <br />
                </div>

                <br />
              </div>
            </div>

            <div class="columns is-multiline" v-if="!status">
              <div class="column is-4">
                <!-- Full Name -->

                <div class="field">
                  <label for class="label">
                    <label class="error_text">*</label>
                    Full Name
                  </label>

                  <div class="control">
                    <ValidationProvider name="Full Name" rules="required" v-slot="{ errors }">
                      <input type="text" v-model="data.name" class="input is-focused" placeholder="Full Name"
                        required />

                      <span style="color: red; font-size: 12px">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div class="column is-4">
                <!-- Login Email -->

                <div class="field">
                  <label for class="label">
                    <label class="error_text">*</label>
                    Login Email
                  </label>

                  <div class="control">
                    <ValidationProvider name="Login Email" rules="email" v-slot="{ errors }">
                      <input type="text" v-model="data.email" class="input is-focused" placeholder="Login Email"
                        required />
                      <span style="color: red; font-size: 12px">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                    <span v-if="errorMessage" style="color: red; font-size: 12px">{{ errorMessage }}</span>
                  </div>
                </div>
              </div>

              <div class="column is-4">
                <!-- Password -->

                <div class="field">
                  <label for class="label">
                    <label class="error_text">*</label>
                    Password
                  </label>

                  <div class="control">
                    <ValidationProvider name="Password" rules="required|min:8|max:30" v-slot="{ errors }">
                      <input type="text" v-model="data.password" class="input is-focused" placeholder="Password"
                        required />

                      <span style="color: red; font-size: 12px">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Company information start -->

          <div class="box">
            <div class="columns is-multiline">
              <div class="column is-4">
                <!-- Company Name -->

                <div class="field">
                  <label for class="label">Company Name</label>

                  <div class="control">
                    <input type="text" v-model="data.companyName" class="input is-focused" placeholder="Company Name"
                      required />
                  </div>
                </div>
              </div>

              <div class="column is-4">
                <!-- Industry -->

                <div class="field">
                  <label class="label">
                    <label class="error_text">*</label>
                    Industry
                  </label>

                  <div class="control">
                    <ValidationProvider name="Industry" rules="required" v-slot="{ errors }">
                      <selection v-model="data.industryId" :data="industries" name="Industry" :selection="clickJob"
                        :updateText="selectedJob" />

                      <span style="color: red; font-size: 12px">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div class="column is-4">
                <!-- company size -->

                <div class="field">
                  <label class="label">Company Size</label>

                  <div class="control">
                    <select v-model="data.companySizeId" class="input is-focused">
                      <option v-for="company in companysizes" :key="company.index" :value="company._id">
                        {{ company.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="column is-4">
                <!-- contact number -->

                <div class="field">
                  <label for class="label">Office Telephone Number</label>

                  <div class="control">
                    <input type="text" v-model="data.phone" class="input is-focused" placeholder="12345678" required />
                  </div>
                </div>
              </div>

              <div class="column is-4-desktop">
                <!-- website -->

                <div class="field">
                  <label for class="label">Website</label>

                  <div class="control">
                    <input type="text" v-model="data.website" class="input is-focused"
                      placeholder="https://www.example.com" required />
                  </div>
                </div>
              </div>

              <!-- <div class="column is-4-desktop">
                <div class="field">
                  <label for class="label">Facebook</label>
                  <div class="control">
                    <input type="text" v-model="data.facebook" class="input is-focused" placeholder="Facebook" required />
                  </div>
                </div>
              </div> -->

              <div class="column is-4-desktop">
                <!-- country -->

                <div class="field">
                  <label for class="label">
                    <label class="error_text">*</label>
                    Country
                  </label>

                  <div class="control">
                    <ValidationProvider name="country" rules="required" v-slot="{ errors }">
                      <select v-model="data.country" class="input is-focused">
                        <option v-for="item1 in country" :key="item1.index" :value="item1.name">
                          {{ item1.name }}
                        </option>
                      </select>

                      <span style="color: red; font-size: 12px">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div v-if="data.country == 'Laos'" class="column is-4-desktop">
                <!-- province / stact -->

                <div class="field">
                  <label for class="label">
                    <label class="error_text">*</label>
                    Province / State
                  </label>

                  <div class="control">
                    <ValidationProvider name="province" rules="required" v-slot="{ errors }">
                      <select v-model="data.province" class="input is-focused" @change="chooseProvince(data.province)">
                        <option v-for="(item2, index) in provinces" :value="item2._id" :key="index">
                          {{ item2.name }}
                        </option>
                      </select>

                      <span style="color: red; font-size: 12px">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div v-if="data.country == 'Laos'" class="column is-4-desktop">
                <!-- district / city -->

                <div class="field">
                  <label for class="label">
                    <label class="error_text">*</label>
                    District / City
                  </label>

                  <div class="control">
                    <ValidationProvider name="District" rules="required" v-slot="{ errors }">
                      <select v-model="data.districtId" class="input is-focused">
                        <option v-for="item1 in districts" :key="item1.index" :value="item1._id">
                          {{ item1.name }}
                        </option>
                      </select>

                      <span style="color: red; font-size: 12px">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div class="column is-4-desktop">
                <!-- Village -->

                <div class="field">
                  <label for class="label">
                    <label class="error_text"></label>
                    Address Village
                  </label>

                  <div class="control">
                    <input type="text" v-model="data.village" class="input is-focused" placeholder="Address Village"
                      required />
                  </div>
                </div>
              </div>

              <div class="column is-12">
                <div class="field">
                  <label for class="label">About Company</label>

                  <div class="control">
                    <div v-if="!isLoading">
                      <FroalaEditor v-model="data.aboutCompany" />
                    </div>

                    <FroalaEditor v-if="isLoading" v-model="data.aboutCompany" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Company information end -->

          <!-- Email setting start -->

          <div class="columns">
            <div class="column">
              <div class="box">
                <div class="field">
                  <label class="label">
                    <label class="error_text">*</label>
                    Job Post Notification Email
                  </label>

                  <div class="control1" v-for="(skill, index) in form.key.nortification" :key="index">
                    <ValidationProvider rules="email" style="width: 100%" v-slot="{ errors }">
                      <input type="text" class="input" v-model="form.key.nortification[index]" required />

                      <span style="font-size: 12px; color: red" id="error">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>

                    <div class="option">
                      <i class="fas fa-trash" @click="form.key.nortification.splice(index, 1)"></i>
                    </div>
                  </div>

                  <button class="button info" @click="Nortification()">
                    Add
                  </button>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="box">
                <div class="field">
                  <label class="label">
                    <label class="error_text">*</label>
                    Job Application Email
                  </label>

                  <div class="control1" v-for="(skill, index) in form.key.appliedEmails" :key="index">
                    <ValidationProvider rules="email" style="width: 100%" v-slot="{ errors }">
                      <input type="text" class="input" v-model="form.key.appliedEmails[index]" required />

                      <span style="font-size: 12px; color: red" id="error">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>

                    <div class="option">
                      <i class="fas fa-trash" @click="form.key.appliedEmails.splice(index, 1)"></i>
                    </div>
                  </div>

                  <button class="button info" @click="AppliedEmails()">
                    Add
                  </button>
                </div>
              </div>
            </div>

            <!--notifyExpire-->

            <div class="column">
              <div class="box">
                <div class="field">
                  <label class="label">Job NotifyExpire Email</label>

                  <div class="control1" v-for="(skill, index) in form.key.notifyExpire" :key="index">
                    <ValidationProvider rules="email" style="width: 100%" v-slot="{ errors }">
                      <input type="text" class="input" v-model="form.key.notifyExpire[index]" required />

                      <span style="font-size: 12px; color: red" id="error">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>

                    <div class="option">
                      <i class="fas fa-trash" @click="form.key.notifyExpire.splice(index, 1)"></i>
                    </div>
                  </div>

                  <button class="button info" @click="notifyExpire()">
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Email setting end -->

          <SocialMedia v-model="data.socialMedia" :isSocial="isSocialMedia" />

          <Gallery v-model="data.gelleryFIle" :isGellery="data.gelleryFIle" />

          <ProductService v-model="data.pService" :productServices="productAndService" />

          <Benefits v-model="data.benefits" :isBenefit="data.benefits" />

          <Location v-model="data.map" :isMap="mapCoordinate" />

          <CardCoverImage v-model="data.cardCover" :isCardCover="data.cardCover" />

          <div class="field">
            <div class="control sw-control">
              <div class="sw-container">
                <label class="sw-label" for="use-published" name="published">
                  <input type="checkbox" id="use-published" v-model="data.isFeature" />

                  <div class="sw-slider"></div>
                </label>

                <label for="use-published">Featured Company</label>
              </div>
            </div>
          </div>

          <Theme v-model="data.theme" :isTheme="themes" />

          <VideoLink v-model="data.videoLink" :isLinks="data.videoLink" />

          <FeaturedImage v-model="data.featureFile" :isFeatureImage="data.featureFile" />

          <ProfileImage v-model="data.profileImag" :isProfileImage="data.profileImag" />

          <AboutImage v-model="data.isLink" :isImage="data.isLink" />

          <People v-model="data.people" :isPeople="data.people" />
          
          <button v-if="userId" @click="handleSubmit(updateEmployer)" class="button primary expand">
            <i class="fas fa-save"></i>
            Update
          </button>

          <button v-else @click="handleSubmit(saveEmployerinfo)" class="button primary expand">
            <i class="fas fa-save"></i>
            Save
          </button>
        </ValidationObserver>
      </section>
    </div>
  </transition>
</template>

<script>
import { GET_INDUSTRIES } from "@/graphql/employer/industry";
import { GET_PROVINCES } from "@/graphql/employer/province";
import { ADD_EMPLOYER } from "@/graphql/employer/employer";
import { REUSE, GET_REUSE } from "@/graphql/manage/query";
import selection from "@coms/others/selection";
import { apolloClient } from "@/services/apollo-client";
import FroalaEditor from "@coms/others/FroalaEditor";
import { GET_USER } from "@/graphql/employer/company";
import { ADD_SubEmployer, GET_COMPANY_ALL } from "@/graphql/employer/company";
import { UPDATE_EMPLOYER } from "@/graphql/employer/employer";
import axios from "axios";
import selectionuser from "@coms/others/selectionuser";
import SocialMedia from "./social-media.vue";
import ProductService from "./product-service.vue";
import FeaturedImage from "./featuredImage.vue";
import Theme from "./theme.vue";
import People from "./people.vue";
import Benefits from "./benefits.vue";
import Gallery from "./gallery.vue";
import Location from "./location.vue";
import VideoLink from "./videoLink.vue";
import ProfileImage from "./profile-Image.vue";
import CardCoverImage from './cardCover-Image.vue'
import AboutImage from "./about-image.vue";
export default {
  components: {
    FroalaEditor: FroalaEditor,
    selection,
    FeaturedImage,
    People,
    Benefits,
    ProductService,
    Gallery,
    SocialMedia,
    CardCoverImage,
    Theme,
    Location,
    VideoLink,
    selectionuser,
    ProfileImage,
    AboutImage,
  },
  data() {
    return {
      isSelectedUser: [],
      country: [],
      errorMessage: "",
      clickJob: [],
      selectedJob: [],
      industries: [],
      companysizes: [],
      provinces: [],
      districts: [],
      imageData: null,
      imageDataHighLight: null,
      imageDataBenefit: null,
      errorfileSize: "",
      form: {
        key: {
          nortification: [[]],
          appliedEmails: [[]],
          notifyExpire: [[]],
        },
      },
      data: {
        name: "",
        email: "",
        password: "",
        logo: "",
        companyName: "",
        industryId: [],
        companySizeId: "",
        aboutCompany: "",
        phone: "",
        website: "",
        facebook: "",
        province: "",
        districtId: "",
        village: "",
        country: "Laos",
        nortificationEmails: [],
        appliedEmails: [],
        notifyExpire: [],
        //new field
        socialMedia: {},
        pService: [],
        featureFile: "",
        profileImag: "",
        cardCover: "",
        theme: "",
        isLink: "",
        videoLink: "",
        gelleryFIle: [],
        people: [],
        benefits: [],
        isFeature: false,
        map: "",
      },
      staff: [],
      staffID: [],
      status: false,
      UserId: [],
      userId: "",
      mapCoordinate: [],
      // props
      isSocialMedia: "",
      productAndService: null,
      themes: "",
      bIdx: null,
      isLoading: true,
      editorOption: {
        images_dataimg_filter: function (img) {
          return !img.hasAttribute("internal-blob"); // blocks the upload of <img> elements with the attribute "internal-blob".
        },
        images_upload_handler: async (blobInfo, success) => {
          const formData = new FormData();
          formData.append("file", blobInfo.blob(), blobInfo.filename());
          axios.defaults.headers.common["Authorization"] =
            this.$store.getters.Token;
          const res = await axios.post(`${this.$urlEditorImage}`, formData);
          success(res.data.fileSrc);

          //success('http://192.168.108.200:4000/' + res.data.file)
          // xhr.send(formData)
        },
        plugins:
          "print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
        menubar: "file edit view insert format tools table help",
        toolbar:
          "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",
        toolbar_sticky: true,
        autosave_ask_before_unload: true,
        autosave_interval: "30s",
        autosave_prefix: "{path}{query}-{id}-",
        autosave_restore_when_empty: false,
        autosave_retention: "2m",
        //  image_advtab: true,
        link_list: [
          { title: "My page 1", value: "http://www.tinymce.com" },
          { title: "My page 2", value: "http://www.moxiecode.com" },
        ],
        image_list: [
          { title: "My page 1", value: "http://www.tinymce.com" },
          { title: "My page 2", value: "http://www.moxiecode.com" },
        ],
        image_class_list: [
          { title: "None", value: "" },
          { title: "Some class", value: "class-name" },
        ],
        importcss_append: true,
        file_picker_callback: function (callback, value, meta) {
          /* Provide file and text for the link dialog */
          if (meta.filetype === "file") {
            callback("https://www.google.com/logos/google.jpg", {
              text: "My text",
            });
          }
          /* Provide image and alt text for the image dialog */
          if (meta.filetype === "image") {
            callback("https://www.google.com/logos/google.jpg", {
              alt: "My alt text",
            });
          }
          /* Provide alternative source and posted for the media dialog */
          if (meta.filetype === "media") {
            callback("movie.mp4", {
              source2: "alt.ogg",
              poster: "https://www.google.com/logos/google.jpg",
            });
          }
        },
        templates: [
          {
            title: "New Table",
            description: "creates a new table",
            content:
              '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
          },
          {
            title: "Starting my story",
            description: "A cure for writers block",
            content: "Once upon a time...",
          },
          {
            title: "New list with dates",
            description: "New List with dates",
            content:
              '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
          },
        ],
        template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
        template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
        //selector: 'editor',  // change this value according to your HTML
        font_formats:
          "Phetsarath OT=Phetsarath OT;Saysettha OT=Saysettha OT;Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
        height: 400,
        image_caption: true,
        quickbars_selection_toolbar:
          "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
        noneditable_noneditable_class: "mceNonEditable",
        toolbar_mode: "sliding",
        contextmenu: "link image imagetools table",
        content_style:
          "body { font-family:Phetsarath OT,Arial,sans-serif; font-size:14px }",
      },
    };
  },
  computed: {
    getJobfunction() {
      const filter = this.industries.filter((i) => {
        return this.data.industryId.includes(i._id);
      });
      const mappers = filter.map((i) => i.name);
      return mappers;
    },
  },
  methods: {
    async queryjob() {
      //console.log(this.funcs);
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          type: "Country",
          page: 1,
          perPage: 300,
          search: "",
        },
      });
      this.country = res.data.getReuse.reuseType;
    },
    chooseJob() {
      this.clickJob = !this.clickJob;
      this.data.industryId = this.selectedJob;
      this.staffID = this.isSelectedUser;
    },
    Nortification() {
      this.form.key.nortification.push([]);
    },
    AppliedEmails() {
      this.form.key.appliedEmails.push([]);
    },
    notifyExpire() {
      this.form.key.notifyExpire.push([]);
    },
    CloseModal() {
      this.$emit("CloseModal");
    },
    chooseProvince(_id) {
      const province = this.provinces.find((i) => {
        return i._id.toString() === _id.toString();
      });

      this.districts = province.districts;
      this.data.districtId = this.districts[0]._id;
    },
    async fetchIndustries() {
      const res = await this.$apollo.query({
        query: GET_INDUSTRIES,
      });

      this.industries = res.data.getIndustries;
      this.data.industryId = this.industries[0]._id;
    },
    async fetchCompanysize() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "CompanySize",
        },
      });

      this.companysizes = res.data.getReuses;
      this.data.companySizeId = this.companysizes[0]._id;
    },
    async saveEmployerinfo() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      try {
        let web = this.data.website;
        if (this.data.website === "https://www.example.com") web = "";
        if (!this.$route.params.UserId) {
          if (this.data.country !== "Laos") {
            this.data.districtId = "";
            const data = {
              name: this.data.name,
              email: this.data.email,
              // mobile: parseInt(this.data.mobile),
              password: this.data.password,
              logo: this.data.logo,
              companyName: this.data.companyName,
              aboutCompany: this.data.aboutCompany,
              industryId: this.data.industryId,
              companySizeId: this.data.companySizeId,
              website: web,
              nortificationEmails: this.form.key.nortification,
              appliedEmails: this.form.key.appliedEmails,
              notifyExpire: this.form.key.notifyExpire,
              village: this.data.village,
              districtId: this.data.districtId,
              country: this.data.country,
              phone: this.data.phone,
              pService: this.data.pService,
              facebook: this.data.socialMedia.facebook,
              youtube: this.data.socialMedia.youtube,
              titok: this.data.socialMedia.titok,
              twitter: this.data.socialMedia.twitter,
              linkIn: this.data.socialMedia.linkIn,
              Profile: this.data.profileImag,
              featureProfile: this.data.featureFile,
              Gallerys: this.data.gelleryFIle,
              Peoples: this.data.people,
              Benefits: this.data.benefits,
              companyColor: this.data.theme.companyColor,
              textColor: this.data.theme.textColor,
              isLink: this.data.isLink,
              isFeature: this.data.isFeature,
              lng: this.data.map.lng,
              lat: this.data.map.lat,
              videoLink: this.data.videoLink,
              cardCover: this.data.cardCover
            };
            await apolloClient.mutate({
              mutation: ADD_EMPLOYER,
              variables: data,
            });
          } else {
            const data = {
              name: this.data.name,
              email: this.data.email,
              // mobile: parseInt(this.data.mobile),
              password: this.data.password,
              logo: this.data.logo,
              companyName: this.data.companyName,
              aboutCompany: this.data.aboutCompany,
              industryId: this.data.industryId,
              companySizeId: this.data.companySizeId,
              website: web,
              nortificationEmails: this.form.key.nortification,
              appliedEmails: this.form.key.appliedEmails,
              notifyExpire: this.form.key.notifyExpire,
              village: this.data.village,
              districtId: this.data.districtId,
              country: this.data.country,
              phone: this.data.phone,
              pService: this.data.pService,
              facebook: this.data.socialMedia.facebook,
              youtube: this.data.socialMedia.youtube,
              titok: this.data.socialMedia.titok,
              twitter: this.data.socialMedia.twitter,
              linkIn: this.data.socialMedia.linkIn,
              Profile: this.data.profileImag,
              featureProfile: this.data.featureFile,
              Gallerys: this.data.gelleryFIle,
              Peoples: this.data.people,
              Benefits: this.data.benefits,
              companyColor: this.data.theme.companyColor,
              textColor: this.data.theme.textColor,
              isLink: this.data.isLink,
              isFeature: this.data.isFeature,
              lng: this.data.map.lng,
              lat: this.data.map.lat,
              videoLink: this.data.videoLink,
              cardCover: this.data.cardCover
            };
            await apolloClient.mutate({
              mutation: ADD_EMPLOYER,
              variables: data,
            });
          }
        } else {
          if (this.data.country !== "Laos") {
            this.data.districtId = "";
            const data = {
              UserId: this.staffID,
              logo: this.data.logo,
              companyName: this.data.companyName,
              aboutCompany: this.data.aboutCompany,
              industryId: this.data.industryId,
              companySizeId: this.data.companySizeId,
              website: web,
              nortificationEmails: this.form.key.nortification,
              appliedEmails: this.form.key.appliedEmails,
              notifyExpire: this.form.key.notifyExpire,
              village: this.data.village,
              districtId: this.data.districtId,
              country: this.data.country,
              phone: this.data.phone,
              pService: this.data.pService,
              facebook: this.data.socialMedia.facebook,
              youtube: this.data.socialMedia.youtube,
              titok: this.data.socialMedia.titok,
              twitter: this.data.socialMedia.twitter,
              linkIn: this.data.socialMedia.linkIn,
              Profile: this.data.profileImag,
              featureProfile: this.data.featureFile,
              Gallerys: this.data.gelleryFIle,
              Peoples: this.data.people,
              Benefits: this.data.benefits,
              companyColor: this.data.theme.companyColor,
              textColor: this.data.theme.textColor,
              isLink: this.data.isLink,
              isFeature: this.data.isFeature,
              lng: this.data.map.lng,
              lat: this.data.map.lat,
              videoLink: this.data.videoLink,
              cardCover: this.data.cardCover
            };
            await apolloClient.mutate({
              mutation: ADD_SubEmployer,
              variables: data,
            });
          } else {
            const data = {
              UserId: this.staffID,
              logo: this.data.logo,
              companyName: this.data.companyName,
              aboutCompany: this.data.aboutCompany,
              industryId: this.data.industryId,
              companySizeId: this.data.companySizeId,
              website: web,
              nortificationEmails: this.form.key.nortification,
              appliedEmails: this.form.key.appliedEmails,
              notifyExpire: this.form.key.notifyExpire,
              village: this.data.village,
              districtId: this.data.districtId,
              country: this.data.country,
              phone: this.data.phone,
              pService: this.data.pService,
              facebook: this.data.socialMedia.facebook,
              youtube: this.data.socialMedia.youtube,
              titok: this.data.socialMedia.titok,
              twitter: this.data.socialMedia.twitter,
              linkIn: this.data.socialMedia.linkIn,
              Profile: this.data.profileImag,
              featureProfile: this.data.featureFile,
              Gallerys: this.data.gelleryFIle,
              Peoples: this.data.people,
              Benefits: this.data.benefits,
              companyColor: this.data.theme.companyColor,
              textColor: this.data.theme.textColor,
              isLink: this.data.isLink,
              isFeature: this.data.isFeature,
              lng: this.data.map.lng,
              lat: this.data.map.lat,
              videoLink: this.data.videoLink,
              cardCover: this.data.cardCover
            };
            await apolloClient.mutate({
              mutation: ADD_SubEmployer,
              variables: data,
            });
          }
        }
      } catch ({ graphQLErrors }) {
        const errorText = graphQLErrors[0].message;
        switch (errorText) {
          case "This e-mail already registered":
            return (this.errorMessage = "ອີເມວນີ້ໄດ້ລົງທະບຽນແລ້ວ");
          case "This mobile phone already registered":
            return (this.errorMessage = "ເບີໂທນີ້ໄດ້ລົງທະບຽນແລ້ວ");
        }
      }
      this.$emit("CloseModal");
    },
    async fetchProvince() {
      const res = await apolloClient.query({
        query: GET_PROVINCES,
      });

      this.provinces = res.data.getProvinces;
      this.data.province = this.provinces[0]._id;
      this.chooseProvince(this.provinces[0]._id);
    },
    chooseImage() {
      this.$refs.fileinput.click();
    },
    uploadFile() {
      this.$refs.fileinput.click();
    },
    async onSelectFile() {
      const input = this.$refs.fileinput;
      const files = input.files;

      const file = files[0];
      // console.log(size, "MB")

      const formData = new FormData();

      formData.append("file", file);
      // console.log(formData)
      if (file) {
        const filesize = file.size / 1024;
        // console.log(filesize, "KB")
        const size = 5 * 1024;
        if (filesize < size) {
          // this.errorfileSize = file.name
          //const header = ` ${this.$store.getters.Token}`

          axios.defaults.headers.common["Authorization"] =
            this.$store.getters.Token;
          const res = await axios.post(`${this.$urlImage}`, formData);
          this.imageData = `${this.$urlImageShow}` + res.data.fileKey;
          if (res.data.message) {
            this.errorfileSize = "The file must be .JPG, .PNG. JPEG, .SVG";
            this.data.logo = null;
            this.imageData = null;
          }
          if (res.data.fileKey) {
            this.errorfileSize = file.name;
            this.data.logo = res.data.fileKey;

            if (files && files[0]) {
              const reader = new FileReader();
              reader.onload = (e) => {
                this.imageData = e.target.result;
              };
              reader.readAsDataURL(files[0]);
              this.$emit("input is-focused", files[0]);
            }
          }
          // console.log(res.data.file.size)
        } else {
          this.errorfileSize = "The file Size is too much";
          this.imageData = null;
        }
      }
    },
    // new function
    uploadFile1() {
      this.$refs.fileinput1.click();
    },
    async onSelectFile1() {
      const input = this.$refs.fileinput1;
      const files = input.files;

      const file = files[0];
      // console.log(size, "MB")

      const formData = new FormData();

      formData.append("file", file);
      // console.log(formData)
      if (file) {
        const filesize = file.size / 1024;
        // console.log(filesize, "KB")
        const size = 5 * 1024;
        if (filesize < size) {
          this.errorfileSize = file.name;
          axios.defaults.headers.common["Authorization"] =
            this.$store.getters.Token;
          const res = await axios.post(`${this.$urlImage}`, formData);
          this.featureProfile = `${this.$urlImageShow}` + res.data.fileKey;
          if (res.data.message) {
            this.errorfileSize = "The file must be .JPG, .PNG. JPEG, .SVG";
            this.data.profile = null;
            this.file = null;
          }
          if (res.data.fileKey) {
            this.errorfileSize = file.name;
            this.data.profile = res.data.fileKey;

            if (files && files[0]) {
              const reader = new FileReader();
              reader.onload = (e) => {
                this.featureProfile = e.target.result;
              };
              reader.readAsDataURL(files[0]);
              this.$emit("input is-focused", files[0]);
            }
          }
        } else {
          this.errorfileSize = "The file Size is too much";
          this.featureProfile = null;
        }
      }
    },

    async queryStaff() {
      const res = await apolloClient.query({
        query: GET_USER,
        variables: {
          UserId: this.$route.params.UserId,
        },
      });
      this.staff = res.data.selectStaff;
      this.staffID = this.staff[0].UserId;
      this.status = true;
    },
    async queryGet_company_all() {
      const res = await apolloClient.query({
        query: GET_COMPANY_ALL,
        variables: {
          id: this.userId,
        },
      });
      this.isLoading = false;
      this.getall = res.data.findEmployer;
      this.isSelectedUser = this.getall.UserId.map((i) => i._id);
      this.data.logo = this.getall.logo;
      this.imageData = `${this.$urlImageShow}` + this.getall.logo;
      this.data.companyName = this.getall.companyName;
      this.data.aboutCompany = this.getall.aboutCompany;
      this.selectedJob = this.getall.industryId.map((i) => i._id);
      this.data.companySizeId = this.getall.companySizeId._id;
      this.data.website = this.getall.website;
      this.form.key.nortification = this.getall.nortificationEmails;
      this.form.key.appliedEmails = this.getall.appliedEmails;
      this.data.village = this.getall.village;
      this.data.country = this.getall.country;
      this.form.key.notifyExpire = this.getall.notifyExpire
        ? this.getall.notifyExpire
        : [];
      this.isSocialMedia = {
        facebook: this.getall.facebook,
        youtube: this.getall.youtube,
        titok: this.getall.titok,
        twitter: this.getall.twitter,
        linkIn: this.getall.linkIn,
      };
      this.data.gelleryFIle = this.getall.Gallerys;
      this.productAndService = this.getall.pService;
      this.data.benefits =
        this.getall.Benefits !== null
          ? this.getall.Benefits.map((i) => ({
            image: i.image,
            details: i.details,
          }))
          : [];
      this.mapCoordinate = this.getall.map.coordinates;
      this.data.isFeature = this.getall.isFeature;
      this.themes = {
        companyColor: this.getall.companyColor,
        textColor: this.getall.textColor,
      };
      this.data.isLink = this.getall.isLink;
      this.data.videoLink = this.getall.videoLink;
      this.data.profileImag = this.getall.Profile;
      this.data.cardCover = this.getall.cardCover;
      this.data.featureFile = this.getall.featureProfile;
      this.data.phone = this.getall.phone;
      this.data.people =
        this.getall.Peoples !== null
          ? this.getall.Peoples.map((i) => ({
            image: i.image,
            name: i.name,
            position: i.position,
            duty: i.duty,
          }))
          : [];
      // this.data.file = this.getall.Profile;
      if (this.getall.country === "Laos") {
        this.data.province =
          this.getall.districtId.provinceId._id !== null
            ? this.getall.districtId.provinceId._id
            : "";
        this.chooseProvince(this.data.province);
        this.$nextTick(() => {
          this.data.districtId = this.getall.districtId._id;
        });
      }
    },
    //update employer
    async updateEmployer() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      let web = this.data.website;
      if (this.data.website === "https://www.example.com") web = "";
      if (this.data.country !== "Laos") {
        this.data.districtId = "";
        const data = {
          employerId: this.userId,
          UserId: this.staffID,
          logo: this.data.logo,
          companyName: this.data.companyName,
          aboutCompany: this.data.aboutCompany,
          industryId: this.data.industryId,
          companySizeId: this.data.companySizeId,
          website: web,
          nortificationEmails: this.form.key.nortification,
          appliedEmails: this.form.key.appliedEmails,
          notifyExpire: this.form.key.notifyExpire,
          village: this.data.village,
          districtId: this.data.districtId,
          country: this.data.country,
          phone: this.data.phone,
          pService: this.data.pService,
          facebook: this.data.socialMedia.facebook,
          youtube: this.data.socialMedia.youtube,
          titok: this.data.socialMedia.titok,
          twitter: this.data.socialMedia.twitter,
          linkIn: this.data.socialMedia.linkIn,
          Profile: this.data.profileImag,
          featureProfile: this.data.featureFile,
          Gallerys: this.data.gelleryFIle,
          Peoples: this.data.people,
          Benefits: this.data.benefits,
          companyColor: this.data.theme.companyColor,
          textColor: this.data.theme.textColor,
          isLink: this.data.isLink,
          isFeature: this.data.isFeature,
          lng: this.data.map.lng,
          lat: this.data.map.lat,
          videoLink: this.data.videoLink,
          cardCover: this.data.cardCover
        };
        await apolloClient.mutate({
          mutation: UPDATE_EMPLOYER,
          variables: data,
        });
      } else {
        const data = {
          employerId: this.userId,
          UserId: this.staffID,
          logo: this.data.logo,
          companyName: this.data.companyName,
          aboutCompany: this.data.aboutCompany,
          industryId: this.data.industryId,
          companySizeId: this.data.companySizeId,
          website: web,
          nortificationEmails: this.form.key.nortification,
          appliedEmails: this.form.key.appliedEmails,
          notifyExpire: this.form.key.notifyExpire,
          village: this.data.village,
          districtId: this.data.districtId,
          country: this.data.country,
          phone: this.data.phone,
          pService: this.data.pService,
          facebook: this.data.socialMedia.facebook,
          youtube: this.data.socialMedia.youtube,
          titok: this.data.socialMedia.titok,
          twitter: this.data.socialMedia.twitter,
          linkIn: this.data.socialMedia.linkIn,
          Profile: this.data.profileImag,
          featureProfile: this.data.featureFile,
          Gallerys: this.data.gelleryFIle,
          Peoples: this.data.people,
          Benefits: this.data.benefits,
          companyColor: this.data.theme.companyColor,
          textColor: this.data.theme.textColor,
          isLink: this.data.isLink,
          isFeature: this.data.isFeature,
          lng: this.data.map.lng,
          lat: this.data.map.lat,
          videoLink: this.data.videoLink,
          cardCover: this.data.cardCover
        };
        await apolloClient.mutate({
          mutation: UPDATE_EMPLOYER,
          variables: data,
        });
      }
      this.$emit("CloseModal");
    },
  },
  created() {
    this.fetchIndustries();
    this.fetchProvince();
    this.fetchCompanysize();
    this.queryjob();
    if (this.$route.params.UserId) {
      this.queryStaff();
    }
    setTimeout(() => {
      if (this.userId) {
        this.queryGet_company_all();
      }
    }, 2000);
  },
};
</script>

<style lang="scss">
._modal.company-detail {
  background-color: var(--bg-color);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-height: 100%;
  z-index: 999;
  overflow-y: auto;

  .box-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .box-title {
      font-size: var(--lg-font);
      text-transform: uppercase;
      margin: 0;
    }

    p {
      line-height: 0;
      height: 30px;
      display: flex;
      align-items: center;
      margin-left: 10px;
      background-color: var(--light-grey-color);
      padding: 0 10px;
      border-radius: 5px;
      font-weight: 500;
      color: var(--font-color);
      font-size: var(--md-font);
    }
  }

  .grid {
    border: 1px solid var(--border-color);
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    i {
      cursor: pointer;
      top: 0;
      right: 0;
      position: absolute;
      width: 30px;
      height: 30px;
      border-radius: 0 0 0 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(var(--alert-color-rgb), 0.1);
      color: var(--alert-color);
    }

    .grid-info {
      margin-top: 20px;
      width: 100%;

      input {
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }

  .card {
    box-shadow: none;
    border: 1px solid var(--border-color);

    .staff-img {
      position: relative;
      overflow: hidden;
      width: 120px;
      height: 120px;
      border-radius: 50%;
      margin: 20px auto 10px;

      &::before {
        display: block;
        content: "";
        width: 100%;
        padding-top: 70%;
      }

      img {
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
    }

    .card-content {
      padding: 10px;

      input {
        margin-bottom: 5px;
      }
    }
  }

  .option {
    display: flex;
    align-items: center;
    padding: 5px;
    background-color: border-color;
    box-shadow: none;
    border: none;
    justify-content: center;
    width: 30px;
    cursor: pointer;

    i {
      color: orangered;
    }
  }

  .error_text {
    color: red;
  }

  .email {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    i {
      padding: 10px;
      color: var(--alert-color);
      cursor: pointer;
    }
  }

  .upload-photo {
    display: flex;
    align-items: center;
    margin-right: 10px;
    margin-bottom: 10px;

    h3 {
      color: var(--font-color);
      font-size: 16px;
      font-weight: 700;
    }

    p {
      font-size: 14px;
    }

    .user-image {
      border: 2px solid var(--primary-color);
      min-width: 120px;
      min-height: 120px;
      border-radius: 50%;
      background-image: url("https://lab-108-bucket.s3.ap-southeast-1.amazonaws.com/assistant-logo/noLogo.jpeg");
      background-size: cover;
      background-position: center center;
      cursor: pointer;
      margin-right: 10px;
    }
  }

  .close {
    cursor: pointer;
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    right: 0;
    z-index: 999;
    border-radius: 0 0 0 10px;
    background-color: var(--alert-color);
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: var(--md-font);
      color: #fff;
    }
  }

  .error {
    color: red;
  }

  .section {
    overflow: hidden;
    height: 100%;
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all ease-in-out 0.3s;
}

.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-100px);
}

.control1 {
  display: flex;
  margin-bottom: 10px;
}

.option {
  display: flex;
  align-items: center;
  padding: 5px;
  background-color: border-color;
  box-shadow: none;
  border: none;
  justify-content: center;
  width: 30px;
  cursor: pointer;

  i {
    color: orangered;
  }
}

.mobile-format {
  display: flex;
  align-items: center;
  position: relative;

  span {
    position: absolute;
    margin-right: 10px;
    color: var(--primary-color);
    font-weight: 700;
    z-index: 999;
    left: 10px;
  }

  input.input {
    padding-left: 70px;
  }
}
</style>
